const system = {
  state: () => ({
    /** 新增/編輯廠區對話框是否顯示 */
    factoryDialogVisible: false,

    /** 新增/編輯季度線排程設定對話框是否顯示 */
    reviewScheduleDialogVisible: false,

    /** 新增/編輯基礎權限設定 */
    basicAuthoritySettingVisible: false,

    /** 基礎權限設定-權限 */
    authorityUpdateVisible: false,

    /** 新增/編輯 廠區使用者設定對話框是否顯示 */
    buUserSettingsDialogVisible: false,

    /** 新增/編輯 帳號管理對話框是否顯示 */
    accountManagementDialogVisible: false,
  }),

  mutations: {
    /** 是否顯示廠區對話框設值 */
    setFactoryDialogVisible(state, value) {
      state.factoryDialogVisible = value;
    },

    /** 是否顯示季度線排程設定對話框設值 */
    setReviewScheduleDialogVisible(state, value) {
      state.reviewScheduleDialogVisible = value;
    },

    /** 是否顯示基礎權限設定對話框設值 */
    setBasicAuthoritySettingVisible(state, value) {
      state.basicAuthoritySettingVisible = value;
    },

    /** 是否顯示基礎權限設定-權限 */
    setAuthorityUpdateVisible(state, value) {
      state.authorityUpdateVisible = value;
    },

    /** 是否顯示廠區使用者設定對話框設值 */
    setbuUserSettingsDialogVisible(state, value) {
      state.buUserSettingsDialogVisible = value;
    },

    /** 是否顯示帳號管理對話框設值 */
    setAccountManagementDialogVisible(state, value) {
      state.accountManagementDialogVisible = value;
    },
  },
};

export default system;
